
import React from 'react';
import { cn } from '@/lib/utils';
import { TopicType } from '@/types/assistant';
import { TOPIC_CONFIG } from '@/contexts/AiAssistantContext';
import { StreamingIndicator } from './StreamingIndicator';

interface MessageHeaderProps {
  isAi: boolean;
  topic: TopicType;
  isStreaming: boolean;
  timestamp: string;
}

export const MessageHeader: React.FC<MessageHeaderProps> = React.memo(({ 
  isAi, 
  topic, 
  isStreaming, 
  timestamp 
}) => {
  const topicConfig = TOPIC_CONFIG[topic];

  return (
    <div className={cn(
      "flex items-center mb-2",
      !isAi && "flex-row-reverse"
    )}>
      <div className="flex items-center">
        {isAi ? (
          // AI messages: AI name first, then timestamp
          <>
            <span 
              className={cn(
                "text-sm font-medium leading-tight",
                isStreaming ? "text-blue-400" : topicConfig.color
              )}
            >
              {topicConfig.label}
              <StreamingIndicator isStreaming={isStreaming} />
            </span>
            
            <span className={cn(
              "text-xs text-muted-foreground/70 opacity-0 group-hover:opacity-100",
              "transition-opacity duration-200 font-normal leading-none ml-3"
            )}>
              {timestamp}
            </span>
          </>
        ) : (
          // User messages: timestamp first, then "You"
          <>
            <span className={cn(
              "text-xs text-muted-foreground/70 opacity-0 group-hover:opacity-100",
              "transition-opacity duration-200 font-normal leading-none mr-3"
            )}>
              {timestamp}
            </span>
            
            <span className="text-sm font-medium leading-tight text-primary">
              You
            </span>
          </>
        )}
      </div>
    </div>
  );
});

MessageHeader.displayName = "MessageHeader";
